import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IOption } from 'ng-uikit-pro-standard';
import { Observable, of, merge } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FormElementViewModel, IFormElementViewModel, IFormElementViewModelOptions } from '../forms';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent implements OnInit {

  optionValue: string = '';
  validationErrors: string[] = [];

  @Input() vm: IFormSelectViewModel;

  @Input() divClass: string = "md-form";

  @Output() selectChanged = new EventEmitter<IFormSelectChangedArg>();

  /**
   * 
   */
  constructor() { }

  /**
   * 
   */
  ngOnInit() {
    if (!this.vm) {
      this.validationErrors = ['no view model'];
      return;
    }

    this.optionValue = this.vm.dataGet();
    this.validationErrors = this.vm.validate(this.vm);
  }

  /**
   * 
   * @param value
   */
  modelChanged(value: string) {
    if (this.vm) {
      this.vm.dataSet(value);
    }
    
    this.optionValue = value;
    this.validationErrors = this.vm.validate(this.vm);

    const option = this.vm.options.find(o => o.value == value);
    this.selectChanged.emit({ sender: this, errors: this.validationErrors, option: option });
  }
  
  /**
   * 
   * @param context 
   * @param field 
   * @param options
   * @param elementInstance 
   * @returns 
   */
  public static viewModel(context: any, field: string, options: IFormSelectOptions, elementInstance: number = undefined): IFormSelectViewModel {
    const ret: IFormSelectViewModel = {
      ...FormElementViewModel.create(context, field, options, elementInstance),

      validate: (vm: IFormSelectViewModel) => {
        const errors: string[] = [
          vm.isRequired && (vm.dataGet() ?? "").length == 0 ? 'Required' : undefined
        ];
        return errors.filter(e => e);
      }
    };
    return ret;
  }
}

/**
 * 
 */
export interface IFormSelectChangedArg {
  sender: FormSelectComponent;
  errors: string[];
  option: IOption;
}

/**
 *
 */
export interface IFormSelectViewModel extends IFormElementViewModel, IFormSelectOptions {
}


/**
 * 
 */
export interface IFormSelectOptions extends IFormElementViewModelOptions {
  placeholder: string;
  options: IOption[];
}